import { render, staticRenderFns } from "./Lumiere.vue?vue&type=template&id=fc93d822&"
import script from "./Lumiere.vue?vue&type=script&lang=js&"
export * from "./Lumiere.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports